import React from 'react';
import useLaunchProjectNavigator from './launchProjectNavigator';
import BaseSelectGroupsPage from './Shared/BaseSelectGroupsPage';
import LaunchProjectSteps, { LaunchProjectStepId } from './LaunchProjectSteps';
import { useProjectContext } from '../view/ProjectContext';
import { ProjectTypeContext } from '../../plans/view/ViewPlan';

export default function SelectGroupsPage() {
  const launchProjectNavigator = useLaunchProjectNavigator();

  const { data } = useProjectContext();

  if (data) {
    return (
      <ProjectTypeContext projectType={data.type}>
        <BaseSelectGroupsPage
          onPrevClicked={() => {
            launchProjectNavigator.openUpdateProjectPage();
          }}
          onNextClicked={() => {
            launchProjectNavigator.openKeyDateTasksPage();
          }}
          roadmap={<LaunchProjectSteps currentStep={LaunchProjectStepId.GROUPS} />}
        />
      </ProjectTypeContext>
    );
  } else {
    return null;
  }
}
